var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.dialog ? _vm.DialogScrollLock : 'div', {
    tag: "component",
    attrs: {
      "width": "800",
      "value": _vm.value
    },
    on: {
      "input": function (v) {
        return _vm.$emit('input', v);
      }
    }
  }, [_c('error-dialog', {
    attrs: {
      "status": _vm.loadStatus
    }
  }), _c('v-card', {
    attrs: {
      "dark": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "aspect-ratio": 16 / 9
    }
  }, [_vm.loadStatus.pending || !_vm.project ? _c('div', {
    staticClass: "absolute-fill d-flex justify-center align-center",
    staticStyle: {
      "z-index": "1"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1) : _vm.project.private && _vm.mode == 'sign' && _vm.globalUserId != _vm.owner ? _c('div', {
    staticClass: "absolute-fill d-flex justify-center align-center",
    staticStyle: {
      "z-index": "1"
    }
  }, [_c('div', {
    staticClass: "white--text"
  }, [_vm._v("This video is private")])]) : _vm.src || _vm.error ? _c('video-player', {
    staticClass: "absolute-fill",
    attrs: {
      "allow-fullscreen": "",
      "src": _vm.src,
      "error": _vm.error
    },
    on: {
      "play-video": function ($event) {
        return _vm.$emit('play-video');
      }
    }
  }, [_c('v-card-title', {
    staticClass: "pa-3 d-flex align-center"
  }, [_c('v-spacer'), _c('download-group-video-btn', {
    staticClass: "mr-2",
    attrs: {
      "project": _vm.project
    }
  }), _vm.dialog ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1) : _vm._e()], 1)], 1) : _vm.build ? _c('video-preview-player', {
    attrs: {
      "video": _vm.build
    },
    on: {
      "slow-playback": function ($event) {
        return _vm.$emit('slow-playback');
      },
      "play-video": function ($event) {
        return _vm.$emit('play-video');
      }
    }
  }, [_c('v-card-title', {
    staticClass: "py-3 d-flex align-center"
  }, [_c('v-spacer'), _c('download-group-video-btn', {
    staticClass: "mr-2",
    attrs: {
      "project": _vm.project
    },
    on: {
      "update-notify": function (x) {
        return _vm.project.render_notify = x;
      },
      "reload": _vm.load
    }
  }), _vm.dialog ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }